import LazyLoad from './lazyLoad';
import Animations from './gsap';
const $ = jQuery.noConflict();

'use strict';
const LoadMoreResources = {
	$wrapper: $('.js-post-wrap'),
	page: 1,

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		const _this = this;

		$('.js-load-more').on('click', function() {
			$('.resources-cards__button-loader').addClass('is-active');
			setTimeout(function(){
				$('.resources-cards__button-loader').removeClass('is-active');
			}, 2000);

			const action = 'LoadMoreResources';
			$.ajax({
				type: 'POST',
				// eslint-disable-next-line no-undef
				url: fwsLocalized.ajaxUrl,
				data: {
					action: action,
					page: _this.page + 1,
				},
				success: function(response) {
					console.log(response.htmlPosts);
					$(response.htmlPosts).appendTo('.js-post-wrap');
					_this.page++;
					if (parseInt(_this.page) === parseInt(response.max)) {
						$('.resources-cards__button').addClass('blog-hidden');
					}
					LazyLoad.init();
					Animations.init();
				},

			});
		});
	},
};

export default LoadMoreResources;
